import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { NavigationExtras, Router, RouterModule } from "@angular/router";
import {
  BRAND_MENU,
} from "src/app/authentication/model/auth.enum";
import { ApiSearchUtilService } from "../../service/api-search-util/api-search-util.service";
import { ProfileManagementService } from "../../service/store-management/profile-management/profile-management.service";
import { MaterialModule } from "../../module/material.module";
import { CommonModule } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { I18nPipe } from "../../i18n/pipe/i18n.pipe";
import { MyAldEventDirective } from "../../directives/myald-event.directive";

@Component({
  selector: "rfc-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MaterialModule,
    CommonModule,
    MatExpansionModule,
    MatListModule, 
    MatIconModule, 
    RouterModule,
    I18nPipe,
    MyAldEventDirective
  ]
})
export class SidenavComponent implements OnInit, OnChanges {
  @Input() snav: MatSidenav;
  @Input() sideNavItems: any[];
  menuItems;

  basePath = window.location.hostname;
  constructor(
    private router: Router,
    private apiSearchUtilService: ApiSearchUtilService,
    private profileManagementService: ProfileManagementService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.menuItems = this.sideNavItems;
    console.log('this.menuItems', this.menuItems);
  }

  getMenuLabelStartingFromCaptive(): BRAND_MENU {
    switch (this.basePath) {
      case this.apiSearchUtilService.findTerm(
        this.basePath,
        "fordfleetmanagement"
      ):
        return BRAND_MENU.FFM_FORD;
      case this.apiSearchUtilService.findTerm(this.basePath, "ford"):
        return BRAND_MENU.FORD;
      case this.apiSearchUtilService.findTerm(this.basePath, "ford"):
        return BRAND_MENU.FORD;
      case this.apiSearchUtilService.findTerm(this.basePath, "honda"):
        return BRAND_MENU.HONDA;
      case this.apiSearchUtilService.findTerm(this.basePath, "suzuki"):
        return BRAND_MENU.SUZUKI;
      case this.apiSearchUtilService.findTerm(this.basePath, "landrover"):
        return BRAND_MENU.LAND_ROVER;
      case this.apiSearchUtilService.findTerm(this.basePath, "jaguar"):
        return BRAND_MENU.JAGUAR;
      case this.apiSearchUtilService.findTerm(this.basePath, "lynkco"):
        return BRAND_MENU.LYNKCO;
      case this.apiSearchUtilService.findTerm(this.basePath, "smart"):
        return BRAND_MENU.SMART;
      case this.apiSearchUtilService.findTerm(this.basePath, "omodajaecoo"):
        return BRAND_MENU.OMODA_JAECOO;
      case this.apiSearchUtilService.findTerm(this.basePath, "mg"):
        return BRAND_MENU.MG;
      case this.apiSearchUtilService.findTerm(this.basePath, "fordfleetmanagement"):
        return BRAND_MENU.FFM;
      default:
        return BRAND_MENU.MY_AYVENS;
    }
  }

  ngOnInit(): void {}

  navigateAndCloseSideNav(childSelected): void {
    const profile = this.profileManagementService.getProfileByStore();
    let navigationExtras: NavigationExtras = {};
    this.snav.close();
    //TEMPORANEO
    // if(childSelected.path === '/support/webform' || childSelected.path === '/support/webform-info-history-list' || childSelected.path === '/support/webform-booking-history-list') {
    //   return
    // }
    if(childSelected.path.startsWith("http")){
      window.open(childSelected.path, '_blank').focus();
      
    }
    
    switch (childSelected.path) {
      case '/vehicle/detail-vehicle':
          navigationExtras = {
                state:{
                  contractId: profile.contractId,
                  codPlate: profile.plate,
                  contractPneus: profile.contractId,
                },
              };
          this.router.navigateByUrl('/vehicle/detail-vehicle', navigationExtras)
        break;

        case '/tools-service/history-refuel':
          navigationExtras = {
                state:{
                  id: profile.contractId,
                  codPlate: profile.plate
                },
              };
          this.router.navigateByUrl('/tools-service/history-refuel', navigationExtras)
         break;
    
      default:
        this.router.navigate([childSelected.path]);
        break;
    }
  }

  close(): void {
    this.snav.close();
  }

  // isTooltipEnabled(path: string) {
  //   return path === '/support/webform' || path === '/support/webform-info-history-list' || path === '/support/webform-booking-history-list'

  // }
  
  //per riattivare disabilitazione voce di menu + tooltip scommentare codice temporaneo e inserire su html seguenti:
  //   [matTooltip]="isTooltipEnabled(child.path) ? 'Funzionalità in manutenzione, riprovare più tardi!' : ''"
  //   [matTooltipDisabled]="!isTooltipEnabled(child.path)"
}
